// Plik: components/molecules/AttemptSummaryModal.js
import React, { useState, useEffect, Fragment } from 'react';
// import api from '../../api/apiHelper'; // Usunięte
import axios from 'axios'; // <-- DODANE
import { AUTH_TOKEN_KEY } from '../../utils/dashboardUtils'; // <-- DODANE
import { Dialog, Transition, TransitionChild, DialogPanel } from '@headlessui/react';
import { AiOutlineCheckCircle, AiOutlinePercentage } from 'react-icons/ai';
import OrzelSesjaIcon from '../../img/icons/orzel_ksiazka.png'; // <-- ZMIENIONY IMPORT

// Definicja apiUrl (potrzebna dla axios)
const apiUrl = process.env.REACT_APP_API_SOURCE || "https://matematly.pl/api/";

// ZMIANA: Usunięto listę i funkcję losującą

const AttemptSummaryModal = ({ isOpen, onClose, attemptId }) => {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen && attemptId) {
            setLoading(true);
            const fetchSummary = async () => {
                // ======================= POCZĄTEK ZMIANY (AXIOS) =======================
                const token = localStorage.getItem(AUTH_TOKEN_KEY);
                if (!token) {
                    console.error("Brak tokena, nie można pobrać podsumowania.");
                    setLoading(false);
                    return;
                }

                try {
                    const { data } = await axios.get(
                        `${apiUrl}exams/attempt/summary/${attemptId}/`,
                        {
                            headers: { Authorization: `Token ${token}` }
                        }
                    );
                    setSummary(data);
                } catch (error) {
                    console.error("Błąd pobierania podsumowania:", error);
                } finally {
                    setLoading(false);
                }
                // ======================= KONIEC ZMIANY (AXIOS) =======================
            };
            fetchSummary();
        }
    }, [isOpen, attemptId]); // Usunięto apiUrl z zależności, bo jest stałą

    const renderContent = () => {
        if (loading) {
            return <p className="text-center text-gray-500">Ładowanie wyników...</p>;
        }
        if (!summary) {
            return <p className="text-center text-red-500">Nie udało się załadować wyników.</p>;
        }

        // ZMIANA: Statyczny obiekt komunikatu
        const message = {
            title: "Kolejny krok do przodu!",
            text: "Arkusze to maraton, nie sprint. Każda ukończona próba przybliża Cię do celu. Powodzenia na maturze!"
        };

        return (
            <div className="flex flex-col items-center space-y-4">
                {/* 1. Orzeł */}
                <img src={OrzelSesjaIcon} alt="Orzeł Matematly" className="w-32 h-32 -mt-4" />

                {/* 2. Tytuł i Tekst Motywacyjny */}
                <Dialog.Title as="h3" className="text-2xl font-bold font-apotek uppercase tracking-wider text-gray-900 text-center">
                    {message.title}
                </Dialog.Title>
                <p className="text-center text-sm text-gray-600 -mt-2">
                    {message.text}
                </p>
                
                {/* 3. Nazwa arkusza (jako podtytuł) */}
                <p className="text-center text-xs text-gray-500 font-semibold uppercase tracking-wider pt-2 border-t w-full">
                    {summary.sheet_name}
                </p>

                {/* 4. Statystyki (bez czasu) */}
                <div className="grid grid-cols-2 gap-4 text-center w-full pt-2">
                    {/* Wynik Punktowy */}
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                        <AiOutlineCheckCircle className="w-8 h-8 mx-auto text-green-600" />
                        <p className="text-xs text-gray-500 uppercase font-semibold mt-2">Punkty</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {summary.user_points} / {summary.total_points}
                        </p>
                    </div>
                    {/* Procent */}
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                        <AiOutlinePercentage className="w-8 h-8 mx-auto text-blue-600" />
                        <p className="text-xs text-gray-500 uppercase font-semibold mt-2">Wynik</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {summary.percentage}%
                        </p>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Transition appear show={isOpen} as={Fragment} afterLeave={() => setSummary(null)}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-50" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <TransitionChild
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                {renderContent()}
                                <div className="mt-6">
                                    <button
                                        type="button"
                                        className="w-full inline-flex justify-center rounded-lg bg-[#233855] px-3 py-2 text-sm lg:text-xs font-apotek tracking-widest text-slate-100 shadow-lg hover:bg-[#345081] focus:outline-none"
                                        onClick={onClose}
                                    >
                                        ZAMKNIJ
                                    </button>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default AttemptSummaryModal;